import { render, staticRenderFns } from "./OtherTab.vue?vue&type=template&id=c311265a&"
import script from "./OtherTab.vue?vue&type=script&lang=ts&"
export * from "./OtherTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports